import React from "react";

const FailIcon = (props) => {
  return (
    <div className="fail-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="62"
        height="52"
        viewBox="0 0 62 52"
        fill="none"
      >
        <path
          d="M21.0232 39.0583C22.3237 38.0217 23.876 37.1981 25.5892 36.6358C27.3023 36.0736 29.1419 35.784 31.0002 35.784C32.8585 35.784 34.6981 36.0736 36.4112 36.6358C38.1244 37.1981 39.6767 38.0217 40.9772 39.0583"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.037 25.5842H39.0638"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.963 25.5842H22.9897"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.82886 7.56226H8.85565"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3717 7.56226H14.3985"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9144 7.56226H19.9412"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.1158 1.13037H5.88429C3.90271 1.13037 2.29633 2.52218 2.29633 4.23907V47.7608C2.29633 49.4777 3.90271 50.8695 5.88429 50.8695H56.1158C58.0974 50.8695 59.7037 49.4777 59.7037 47.7608V4.23907C59.7037 2.52218 58.0974 1.13037 56.1158 1.13037Z"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.177 14.1108H59.8219"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default FailIcon;
